import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import eyeShowIcon from '../../assets/icons/eye-closed.svg';
import eyeHideIcon from '../../assets/icons/eye-open.svg';

interface InputProps {
  id: string;
  label: React.ReactNode;
  type?: string;
  value: string;
  error?: string;
  required?: boolean;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  autoComplete?: string;
  disabled?: boolean;
  placeholder?: string;
  min?: number | string;
  max?: number | string;
  step?: number | string;
  maxLength?: number;
}

const Input: React.FC<InputProps> = ({
  id,
  label,
  type = 'text',
  value,
  error,
  required = false,
  onChange,
  onFocus,
  onBlur,
  autoComplete,
  disabled = false,
  placeholder = '',
  min,
  max,
  step,
  maxLength
}) => {
  const { t } = useTranslation();
  const [isFocused, setIsFocused] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
    if (onFocus) {
      onFocus();
    }
  };

  const handleBlur = () => {
    setIsFocused(false);
    if (onBlur) {
      onBlur();
    }
  };

  const actualType = type === 'password' && showPassword ? 'text' : type;

  return (
    <div className="form-field">
      <label htmlFor={id}>{label}</label>
      <div className={`input-container ${type === 'password' ? 'password-input' : ''}`}>
        <input
          id={id}
          type={actualType}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={handleFocus}
          onBlur={handleBlur}
          className={!isFocused && error ? 'error' : ''}
          // required={required}
          autoComplete={autoComplete}
          disabled={disabled}
          placeholder={placeholder}
          min={min}
          max={max}
          step={step}
          maxLength={maxLength}
        />
        {type === 'password' && (
          <button
            type="button"
            className="password-toggle"
            onClick={() => setShowPassword(!showPassword)}
          >
            <img src={showPassword ? eyeShowIcon : eyeHideIcon} alt="eye" />
          </button>
        )}
      </div>
      {!isFocused && error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default Input; 